angular.module('zc.projects')

.directive 'totalStats', (AccessStats, Devise, currencies) ->
  return {
    restrict: 'E'
    require: '?filters'
    templateUrl: '/templates/projects.analytics/views/directives/total_stats.html'
    scope:
      filters: '='
      project: '='
    link: (scope, element, attrs) ->
      scope.Devise = Devise
      update = ->
        scope.currency = currencies[scope.project.currency]
        AccessStats.aggregateByFilter
          apikey: scope.project.apikey
          dimension: 'daily'
        , scope.filters
        .then (access_stats) ->
          scope.stats = access_stats[0]

      update()
      scope.$on 'filtersUpdated', update
  }



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.analytics/directives/total_stats.js.coffee